"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NaniClubRedirect = _interopRequireDefault(require("./NaniClubRedirect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _NaniClubRedirect.default;
exports.default = _default;